<template>
  <div class="page-container">
    <v-page-header title="公众号账号">
      <lamp-tip local-key="mng.accountInfo.list">
        <div class="lamptip-desc">
          <p class="intro-desc">1、公众号类型：仅支持绑定微信公众号；未认证公众号绑定后将提示绑定失败。</p>
          <p class="intro-desc">2、绑定时的权限授予：为了微信公众号的相关功能均可正常使用，绑定时需至少授予消息管理权限、自定义菜单权限、网页服务权限、群发与通知权限、用户管理权限、帐号服务权限、素材管理权限</p>
          <p class="intro-desc">
            3、公众号数据：可至<a target="_blank" href="https://mp.weixin.qq.com/">微信公众平台</a>查看相关数据
          </p>
          <p class="intro-desc">4、由于公众号平台调整，企点不再支持QQ公众号绑定</p>
        </div>
    </lamp-tip>
    </v-page-header>
      <v-tip ref="bindTip" placement="top" :disabled="listTotal < maxCount">
        <span>最多绑定{{ maxCount }}个公众号</span>
      </v-tip>
      <div v-if="pagination.total >= maxCount" v-tip:bindTip.hover :class="{ 'account-auth-item--disabled': listTotal >= maxCount }"
        class="account-auth-list_item"
      >
        <v-icon name="app_weixin_line" remote class="bind-icon" />
        <div>
          <h4 class="bind-text-top">绑定微信公众号</h4>
          <p class="bind-text-bot">一键授权绑定微信公众号到企点</p>
        </div>
      </div>
      <div v-else class="account-auth-list">
        <div class="account-auth-list_item" @click="onAuth">
          <v-icon name="app_weixin_line" remote class="bind-icon" />
          <div>
            <h4 class="bind-text-top">绑定微信公众号</h4>
            <p class="bind-text-bot">一键授权绑定微信公众号到企点</p>
          </div>
        </div>
      </div>
      <div class="account-auth-table">
        <v-table
          :data="options"
          :auto="false"
          :pagination="pagination"
          @paginationChange="paginationChange"
        >
          <v-table-column
            v-for="(column, index) in columns"
            :key="`grid-col-${index}`"
            :column-key="columnsOption[column].value"
            :label="columnsOption[column].label"
            :width="columnsOption[column].width"
            :align="columnsOption[column].align"
            :render="columnsOption[column].render"
            :fixed="columnsOption[column].fixed"
          />
          <v-table-column width="250">
            <template slot="cell" slot-scope="props">
              <div v-if="props.row.wxFunc_1 == 0" class="text-err-auth">
                <div v-if="props.row.errMsg && props.row.errMsg.title">
                  {{ props.row.errMsg.title }}
                </div>
                <div v-if="props.row.errMsg && props.row.errMsg.tips">
                  {{ props.row.errMsg.tips }}
                </div>
              </div>
              <div v-else-if="props.row.accountStatus == 3 || props.row.wxBindSucc == 0">
                <span class="text-err">{{ props.row.errMsg && props.row.errMsg.title || '读取失败或超时' }}
                  <v-tip v-if="props.row.errMsg && props.row.errMsg.tips" ref="msgTip" placement="top">
                      {{ props.row.errMsg && props.row.errMsg.tips }}
                    </v-tip>
                  <v-icon v-if="props.row.errMsg && props.row.errMsg.tips" v-tip:msgTip.hover name="basic_tips_fill" color="res" remote size="18" />
                </span>
              </div>
              <div v-else-if="props.row.accountStatus == 2">
                <span>{{ props.row.wxSyncStatus ? (props.row.wxSyncStatus != 0 ? '正在' : '') + syncStatusText[props.row.wxSyncStatus] : '正在读取中' }}</span>
              </div>
              <div v-else>
                <span v-if="props.row.verifyStatus == 2 ">
                  <span class="text-err">审核未通过</span>
                </span>
                <span v-else-if="props.row.verifyStatus == 1">
                  <span class="text-err">审核中</span>
                </span>
              </div>
            </template>
          </v-table-column>
          <v-table-column width="150">
            <template slot="cell" slot-scope="props">
              <div v-if="props.row.wxFunc_1 == 0 || props.row.wxBindSucc == 0">
                <v-button type="link" kind="primary" @click="onAuth">
                  重新绑定
                </v-button>
                <br>
                <v-button type="link" kind="primary" @click="unBind(props.row, 'remove')">
                  移除
                </v-button>
              </div>
              <div v-else-if="props.row.accountStatus == 3">
                <v-button type="link" kind="primary" @click="reloadStatus(props.row)">
                  重新读取
                </v-button>
                <br>
                <v-button type="link" kind="primary" @click="unBind(props.row)">
                  解除绑定
                </v-button>
              </div>
              <div v-else>
                <v-button v-if="props.row.verifyStatus == 3" type="link" kind="primary" @click="unBind(props.row)">
                  解除绑定
                </v-button>
                <span v-else-if="props.row.verifyStatus == 2">
                  <v-button v-if="props.row.updateOpenQQUrl" @click="review(props.row)">重新提交审核</v-button>
                </span>
              </div>
            </template>
          </v-table-column>
          <div slot="nodata">
            <v-icon name="default_common" size="100" remote />
            <br>
            暂无公众号
          </div>
        </v-table>
      </div>
  </div>
</template>

<script>
import conf from './conf';
import LampTip from '@/components/lamp-tip';
export default {
  components: {
    LampTip,
  },

  data() {
    return {
      conf,
      columns: ['accountName', 'wxAppType', 'accountIntro'],
      columnsOption: conf.wxGridConf.columnsOption,
      maxCount: 0,
      pagination: {
        count: 15,
        index: 1,
        total: 0,
      },
      options: [],
      syncStatusText: conf.syncStatusText,
    };
  },
  created() {
    // 兜底新版导航的坑：set=null。
    let { set } = window.QD_ADMIN_COMMON?.data || {};
    if (!set) { set = {}; }
    const isYx = set.currentClass === 'yx' || set.currentClass === 'pdm' || set.current === '10074';
    this.columns = this.columns.concat(isYx ? ['accountSetting'] : []);
    this.isDefaultMax = (set.available || []).some((el) => {
      return (el.id === 10007) || (el.id === 10009);
    });
    this.getTotal();
  },
  methods: {
    getTotal() {
      this.$ajax.gatewayGet('/mp/accountInfo/getTotal').then((res) => {
        const { data } = res || {};
        this.maxCount = this.isDefaultMax ? data.maxCount : data.defaultCount;
        this.$set(this.pagination, 'total', data.listTotal || 0);
        this.$set(this.pagination, 'index', 1);
        this.getList();
      })
      .catch((err) => {
        this.$message.error(err.msg || err.message || '拉取数据出错');
      });
    },
    paginationChange(pageNum, pageSize) {
      this.pagination.count = pageSize;
      this.pagination.index = pageNum;
      this.getList();
    },
    onAuth() {
      this.$ajax.gatewayGet(conf.getWxAuthCgi).then(() => {
        window.location = `/mp/oauth/url?jump=1&stamp=${new Date().getTime()}`;
      });
    },
    reloadStatus(item) {
      this.$ajax.gatewayPost(conf.reloadStatusCgi, {
        id: item.id,
      }).then(() => {
        this.getList();
      });
    },
    review(item) {
      window.open(`/mp/wxPubQQ/getWxAccountInfoEp?id=${item.id}`);
    },
    //  请求列表数据
    getList() {
      this.$ajax.gatewayGet('/mp/accountInfo/getAccountInfo', {
        count: this.pagination.count,
        index: this.pagination.index,
       }).then((res) => {
        this.options = res || [];
      })
      .catch((err) => {
        this.$message.error(err.msg || err.message || '拉取数据出错');
      });
    },
    unBind(item, type) {
      const that = this;
      const text = type === 'remove' ? '移除' : '解绑';

      const dialog = this.$confirm({
        title: `${text}该公众号？`,
        content: `${text}后，所有配置将无法应用到您的帐号。`,
        status: 'warning',
        confirmText: text,
        confirm(e) {
          e.preventDefault();
          dialog.showButtonLoading();
          that.$ajax
            .gatewayPost(
            item.type == 1 ? conf.unbindtWxCgi : conf.unbindtQQCgi,
              {
                id: item.id,
              },
            )
            .then(() => {
              that.$message.success(`${text}成功`);
              dialog.$remove();
              that.getTotal();
            })
            .catch((err) => {
              that.$message.error(err.msg || err.message || '解绑失败');
              dialog.$remove();
            });
        },
      });
    },
  },
};
</script>

<style lang="less">
@import './style.less';
</style>
